import { getLocale } from "../runtime";

const sv_ptcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Portugal`
};

const ptcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_ptcountryenglish(inputs)
	return "ptCountryEnglish";
};

export { ptcountryenglish as "ptCountryEnglish" };